import {StatusIndicator} from 'cdk-radial';

enum StatusTypes {
    POSITIVE = 'positive',
    WARNING = 'warning',
}

export const CustomStatusRenderer = ({isActive,startDate, endDate}: any): JSX.Element => {
    let variant = isActive ? StatusTypes.POSITIVE : StatusTypes.WARNING;
    let label = isActive ? 'Active' : 'Inactive';
    if(startDate && new Date(startDate) > new Date()){
        variant = StatusTypes.WARNING;
        label = 'Scheduled'
    }else if(endDate && new Date(endDate) > new Date()){
        variant = StatusTypes.POSITIVE;
        label = 'Active';
    }else if(startDate && new Date(startDate) <= new Date()){
        variant = StatusTypes.POSITIVE;
        label = 'Active';
    }
    return (
        <StatusIndicator
            label={label}
            variant={variant}
            showIcon
        />
    );
};